import { imgixHost } from 'src/config'
import { VIDEO_PLATFORM_OPTIONS } from 'src/models/carousel/Carousel'
import { IsoDate } from 'src/models/Model'

export const createCarouselItem = () => {
  return {
    key: crypto.getRandomValues(new Uint32Array(1))[0],
    title: null,
    showTitle: true,
    description: null,
    image: null,
    mobileImage: null,
    hasLink: false,
    linkUrl: null,
    openInNewTab: false,
    showButton: false,
    buttonText: null,
    showVideo: false,
    videoPlatform: VIDEO_PLATFORM_OPTIONS.VIMEO,
    youtubeVideoId: null,
    showVideoButton: false,
    buttonLabel: 'Trailer',
    buttonLabel_es: 'Tráiler',
    vimeoVideoId: null,
    displayOrder: 100,
    darkMode: true,
    startDate: null,
    endDate: null
  }
}

export function carouselItemClasses (carouselItem) {
  return `carousel-item-${carouselItem.key} carousel-item-${_.kebabCase(carouselItem.title)} `
}

export function carouselItemImageUrl (imageKey) {
  if (!imageKey) return null
  return `${imgixHost}/${imageKey}?auto=format`
}

export function isCarouselItemVisible (carouselItem, currentDate) {
  return (!carouselItem.startDate || currentDate >= carouselItem.startDate) &&
           (!carouselItem.endDate || currentDate <= carouselItem.endDate)
}

export function carouselItemIcon (carouselItem, currentDate) {
  const icons = []

  if (this.isCarouselItemVisible(carouselItem, currentDate) || (!carouselItem.startDate && !carouselItem.endDate)) {
    icons.push({
      name: 'visibility',
      color: 'positive',
      class: 'visibility',
      size: 'sm'
    })
  } else {
    icons.push({
      name: 'visibility_off',
      color: 'negative',
      class: 'visibility',
      size: 'sm'
    })
  }

  if (carouselItem.startDate || carouselItem.endDate) {
    const now = IsoDate.parse(currentDate).i18n('date')
    const startDate = carouselItem.startDate && IsoDate.parse(carouselItem.startDate).i18n('date')
    const endDate = carouselItem.endDate && IsoDate.parse(carouselItem.endDate).i18n('date')

    if (startDate && now <= startDate) {
      icons.push({
        name: 'schedule',
        color: 'positive',
        class: 'schedule',
        tooltip: `Starts on ${startDate}`,
        size: 'xs'
      })
    } else if (endDate && now <= endDate) {
      icons.push({
        name: 'schedule',
        color: 'negative',
        class: 'schedule',
        tooltip: `Ends on ${endDate}`,
        size: 'xs'
      })
    } else if (endDate && now > endDate) {
      icons.push({
        name: 'schedule',
        color: 'grey',
        class: 'schedule',
        tooltip: `Ended on ${endDate}`,
        size: 'xs'
      })
    }
  }

  return icons
}
